var map = {
	"./hero-bg-1200.jpg": 1983,
	"./hero-bg-1200.webp": 1984,
	"./hero-bg-1200x2.jpg": 1985,
	"./hero-bg-1200x2.webp": 1986,
	"./hero-bg-1600.jpg": 1987,
	"./hero-bg-1600.webp": 1988,
	"./hero-bg-1600x2.jpg": 1989,
	"./hero-bg-1600x2.webp": 1990,
	"./hero-bg-1920.jpg": 1991,
	"./hero-bg-1920.webp": 1992,
	"./hero-bg-1920x2.jpg": 1993,
	"./hero-bg-1920x2.webp": 1994,
	"./hero-bg-2560.jpg": 1995,
	"./hero-bg-2560.webp": 1996,
	"./hero-bg-580.jpg": 1997,
	"./hero-bg-580.webp": 1998,
	"./hero-bg-580x2.jpg": 1999,
	"./hero-bg-580x2.webp": 2000,
	"./hero-bg-800.jpg": 2001,
	"./hero-bg-800.webp": 2002,
	"./hero-bg-800x2.jpg": 2003,
	"./hero-bg-800x2.webp": 2004,
	"./hero-bg-full.jpg": 2005,
	"./hero-bg-full.webp": 2006
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1982;